export const FullscreenModal = ({ children }) => {
  return (
    <div className="fixed inset-0 bg-[#EFF6FF] overflow-y-auto h-full w-full">
      <div className="relative h-full">{children}</div>
    </div>
  );
};
